var React = require('react');

function Undo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.53 0c.846 0 1.532.685 1.532 1.53v13.778h13.777a1.53 1.53 0 110 3.062H1.53A1.53 1.53 0 010 16.839V1.53C0 .685.685 0 1.53 0z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.414 16.329A24.493 24.493 0 0124.523 0C38.049.009 49.008 10.982 49 24.508c-.009 13.527-10.981 24.487-24.508 24.478a1.53 1.53 0 11.002-3.062c11.836.008 21.437-9.582 21.444-21.418.008-11.835-9.582-21.437-21.418-21.444A21.431 21.431 0 004.3 17.349a1.53 1.53 0 01-2.886-1.02z","key":1})]);
}

Undo.defaultProps = {"viewBox":"0 0 49 49"};

module.exports = Undo;

Undo.default = Undo;
